import { FC } from 'react';
import { Box, Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';
import { uniq, upperFirst } from 'lodash';

import { GroupedOption } from '../../../../hooks/useRiderOptions';

interface GenderPreferenceModalProps {
  isOpen: boolean;
  riders: GroupedOption[];
  handleSave: () => void;
  handleClose: () => void;
}

export const GenderPreferenceModal: FC<GenderPreferenceModalProps> = ({ isOpen, riders, handleSave, handleClose }) => {
  return (
    <Modal data-testid="ride-gender-modal" open={isOpen} onClose={handleClose}>
      <Modal.Content>
        <ModalContent riders={riders}></ModalContent>
      </Modal.Content>
      <Modal.Actions>
        <Button color="tertiary" onClick={handleClose}>
          Nevermind
        </Button>
        <Button form="rides-form" onClick={handleSave} color="primary" variant="contained" type="submit">
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const ModalContent: FC<Pick<GenderPreferenceModalProps, 'riders'>> = ({ riders }) => {
  const ridersWithPrefs = riders.map((rider) => ({
    fullName: rider.name,
    driverGenderPreferences: rider.driverGenderPreferences?.map((gender) => upperFirst(gender.replace('_', '-'))),
  }));
  const allowedCDGenders = uniq(ridersWithPrefs.flatMap((rider) => rider.driverGenderPreferences));

  return (
    <>
      <Box mb={4}>
        {ridersWithPrefs.map((rider, index) => (
          <Text mb={2} key={`gender-message-${index}`}>
            {`- ${rider.fullName} has a ${rider.driverGenderPreferences?.join(' and ')} CareDriver gender preference.`}
          </Text>
        ))}
      </Box>
      <Text>{`${
        allowedCDGenders.length === 3 ? 'Any' : `A ${allowedCDGenders.join(' or ')}`
      } CareDriver will be able to claim this ride.`}</Text>
    </>
  );
};
